<template>
  <div :class="{ 'ds-root': dsRoot }">
    <div v-if="isLoading && loadingOverlay" class="loader-wrapper">
      <loader class="loader" />
    </div>
    <cst-menu v-if="!hideMenu"></cst-menu>
    <div class="page-content" :style="contentStyle">
      <slot />
    </div>
  </div>
</template>

<script>
import Loader from '@/components/generic/presentational/atoms/loader/Loader.vue'
import CstMenu from '@/components/generic/presentational/molecules/cstMenu/CstMenu.vue'
import { mapGetters, mapState } from 'vuex'

export default {
  components: {
    Loader,
    CstMenu,
  },
  props: {
    loadingOverlay: {
      type: Boolean,
      default: false,
    },
    hideMenu: {
      type: Boolean,
      default: false,
    },
    // Opts this page in to the new design system (styles/ds/). Off by default:
    // a page keeps the legacy look until it is migrated. See styles/ds/README.md.
    dsRoot: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { i18n: window.VUE_CLI_EXPORTS.plugins.i18n }
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.quote.loading,
    }),
    ...mapGetters({
      sidebarOpen: 'ui/sidebarOpen',
      sidebarWidth: 'ui/sidebarWidth',
    }),
    contentStyle() {
      return {
        marginLeft: this.sidebarOpen ? `${this.sidebarWidth}px` : '0',
        transition: 'margin-left 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.loader-wrapper {
  position: absolute;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.7);
}
.loader {
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
